import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { RepairTableDevolutionModalModel } from 'src/app/models/maintenance/repair-table-devolution-modal.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { RepairModel } from './../../../../models/maintenance/repair.model';
import { RepairService } from './../../../../services/maintenance/repair.service';

@Component({
  selector: 'app-repair',
  templateUrl: './repair.component.html',
  styleUrls: ['./repair.component.scss'],
  standalone: false
})
export class RepairComponent implements OnInit {

  ascendant: boolean = true;
  articleId: number = 0;
  changeRepairs: boolean = false;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  detailData: PagedResponseModel<RepairTableDevolutionModalModel> = new PagedResponseModel<RepairTableDevolutionModalModel>();
  devolutionDetailId: number = 0;
  disabledDetail: boolean = false;
  isFormView: boolean = false;
  formRepair: FormGroup = new FormGroup({});
  header: ColumnResponseModel[] = [];
  limit: number = 10;
  listArticle: any[] = [];
  page: number = 1;
  repairContract: RepairModel = new RepairModel();
  suscription: Subscription;
  tableActions: TableAction[] = [];
  unit: string = "";
  totalValue: number = 0;

  constructor(private articleService: ArticleService,
    public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    private confirmDialogService: ConfirmDialogService,
    private repairService: RepairService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
    this.validateForm(new RepairModel());
  }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.devolutionDetailId = inputs.devolutionDetailId;
      this.disabledDetail = inputs.disabledDetail;
    });
    this.tableActions = this.disabledDetail ? [] : this.getDefaultActions();
    if (this.disabledDetail) {
      setTimeout(() => this.formRepair.disable(), 100);
    }
    await this.getAllLists();
    await this.getColumns();
    await this.getAllRepairsWithPagination();
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  calculateValues() {
    const quantity = this.formRepair.get("quantity")?.value;
    const unitValue = this.formRepair.get("unitValue")?.value;
    this.totalValue = quantity * unitValue;
  }

  clearForm() {
    const modelRepair = new RepairModel();
    this.totalValue = 0;
    this.unit = "";
    this.validateForm(modelRepair)
    this.getFormView(false);
  }

  close() {
    this.clearForm();
    const data: ModalObjectType = {};
    if (this.changeRepairs) {
      data.params = { reload: true };
      this.ref.close(data);
    } else {
      data.params = { reload: false };
      this.ref.close(data);
    }
  }

  async deleteRepair(selectedIds: number[]) {
    if (selectedIds.length === 0) return;

    const confirmation = await this.confirmDialogService.confirm('¿Realmente desea eliminar la reparación?')
    if (confirmation) {
      try {
        await firstValueFrom(this.repairService.deleteSomeRepairs(selectedIds));
        this.toastHandlerService.showToast('success', 'La reparación fue eliminada exitosamente.', 'Atención');
      } catch (error) {
        console.error('Error al eliminar la reparación de la orden de mantenimiento .', error);
      }
    };
  }


  async newRepair(button: boolean) {
    this.totalValue = 0;
    this.unit = "";
    this.repairContract = new RepairModel();
    this.validateForm(this.repairContract);
    if (button) this.getFormView(true);
  }

  async getAllLists() {
    try {
      const [articles] = await Promise.all([
        firstValueFrom(this.articleService.getAllSuppliesDevolutionForSelectAsync()),
      ]);
      this.listArticle = articles

      return true;
    } catch (error) {
      console.error('Error to get all lists.', error);
      return false;
    }
  }

  async getAllRepairsWithPagination() {
    try {
      this.detailData = await firstValueFrom(
        this.repairService.getAllRepairsDevolutionModalWithPagination(this.page, this.limit, this.columnSort, this.ascendant, this.devolutionDetailId));
    } catch (error) {
      console.error('Error al buscar los contactos:', error);
    }
  }

  getArticle(articleId: number | null) {
    if (articleId != 0 && articleId != null) {
      const article = this.listArticle.find(x => x.value === articleId);
      if (article) {
        this.unit = article.unit;
      }
    } else {
      this.formRepair.controls["articleId"].setValue(0);
      this.unit = "";
    }
  }

  async getColumns() {
    try {
      this.header = await firstValueFrom(this.repairService.getColumnsForModalDevolution());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta de contactos.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }
    ];
  }

  getFormView(event: boolean) {
    this.isFormView = event;
  }

  async getRepairById(repairId: number) {
    try {
      this.repairContract = await firstValueFrom(this.repairService.getRepairById(repairId));
      this.validateForm(this.repairContract);
      this.getArticle(this.repairContract.articleId);
      this.calculateValues();
    } catch (error) {
      console.error('Error to get repair by id:', error);
    }
  }

  async onAction(event: { action: string, item?: RepairTableDevolutionModalModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      try {
        this.repairContract = await firstValueFrom(this.repairService.getRepairById(event.item.id));
        this.validateForm(this.repairContract);
        const article = this.listArticle.find(x => x.value === this.repairContract.articleId);
        if (article) {
          this.unit = article.unit;
        }
        this.calculateValues();
        this.getFormView(true);
      } catch (error) {
        console.error('Error to edit repair:', error);
      }
    }

    if (event.action === 'bulk-delete' && event.selectedItems) {
      await this.deleteRepair(event.selectedItems);
      this.clearSelectionTrigger++;
      this.repairContract = new RepairModel();
      this.changeRepairs = true;
      this.clearForm();
      this.getFormView(false);
      this.getAllRepairsWithPagination();
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getAllRepairsWithPagination();
  }

  async send() {
    if (this.formRepair.valid) {
      const modelRepair = this.formRepair.value as RepairModel;
      modelRepair.devolutionDetailId = this.devolutionDetailId;

      if (this.repairContract.repairId == 0) {
        try {
          this.repairContract = await firstValueFrom(this.repairService.createRepair(modelRepair));
          this.toastHandlerService.showToast(
            'success',
            'La Reparación fue creada exitosamente.'
          );
          this.changeRepairs = true;
          this.newRepair(false);
          this.getAllRepairsWithPagination();
        } catch (error) {
          console.error('Error to create repair:', error);
        }
      } else {
        this.repairContract.articleId = modelRepair.articleId;
        this.repairContract.detailText = modelRepair.detailText;
        this.repairContract.quantity = modelRepair.quantity;
        this.repairContract.unitValue = modelRepair.unitValue;

        try {
          this.repairContract = await firstValueFrom(this.repairService.updateRepair(this.repairContract));
          this.toastHandlerService.showToast(
            'success',
            'La Reparación fue modificada exitosamente.'
          );
          this.changeRepairs = true;
          this.newRepair(false);
          this.getAllRepairsWithPagination();
        } catch (error) {
          console.error('Error to update repair:', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      articleId: {
        required: 'El campo Artículo es obligatorio.',
        min: 'Debes seleccionar un Artículo válido.'
      },
      detailText: {
        maxlength: 'El Detalle no puede tener más de 70 caracteres.'
      },
      quantity: {
        required: 'El campo Cantidad es obligatorio.',
        min: 'El campo Cantidad debe ser mayor a cero.',
        max: 'El campo Cantidad no puede superar 9.999.999,99.',
      },
      unitValue: {
        required: 'El campo Vr.Unit. es obligatorio.',
        min: 'El campo Vr.Unit. no puede ser negativo.',
        max: 'El campo Vr.Unit. no puede superar 9.999.999,99.',
      },
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formRepair.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm(repair: RepairModel) {
    this.formRepair = this.formBuilder.group({
      consecutive: [repair.consecutive, [Validators.required]],
      articleId: [repair.articleId, [Validators.required, Validators.min(1)]],
      detailText: [repair.detailText, [Validators.maxLength(70)]],
      quantity: [repair.quantity, [Validators.required, Validators.min(0), Validators.max(9999999.99)]],
      unitValue: [repair.unitValue, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]]
    });
  }

}
